import React from 'react';
import { MenuItem } from '../models/Category';

// Export the ItemCardProps interface
export interface ItemCardProps {
  item: MenuItem;
  language: 'en' | 'gr'; // Add language prop
  onImageClick: (item: MenuItem) => void; // Add callback for image click
  title: string; // Add title
  description: string; // Add description
  price: number; // Add price
}

const ItemCard: React.FC<ItemCardProps> = ({ item, onImageClick, title, description, price }) => {
  return (
    <article className={`item-card${item.img ? ' item-card--has-image' : ''}${description ? ' item-card--has-desc' : ''}`}>
      {item.img && (
        <button
          type="button"
          className="item-card__thumb"
          onClick={() => onImageClick(item)}
          aria-label={`View photo of ${title}`}
        >
          <span
            className="item-card__thumb-img"
            style={{ backgroundImage: `url(${item.img})` }}
          />
        </button>
      )}

      <div className="item-card__body">
        <div className="item-card__heading">
          <h3 className="item-card__name">{title}</h3>
          <span className="item-card__price item-price">{price.toFixed(2)}€</span>
        </div>
        {description && <p className="item-card__desc">{description}</p>}
      </div>
    </article>
  );
};

export default ItemCard;
